import { getXmlFile } from '../common/xmlretriever';
import { parseXMLtoJS }  from '../common/parseXMLtoJS';

import { prepareBookDataModel, prepareChapterDataModel } from '../datamodel/prepareDataModel';

class BookDM {
    constructor() {
        this.basePath = '';
        this.title = '';
        this.authors = '';
        this.isbn = '';
        this.fontSize = 19;
        this.lineThickness = 2;
        this.answerResultIndicatorSize = 18;
        this.config = { answerResultIndicatorSize: 18,
                        drawingLineThickness: 2,
                        fontSize: 19,
                        flashcardMode: false};
        this.chapters = [];
        this.isLoaded = false;
        this.runtime = { currentPageNumber: 0,
                         currentScaleFactor: 1,
                         currentPageModel: null,
                         currentChapterModel: null,
                         drawingPanel: null }
    }

    static parsePageRangeIntoArray(strValue) {
        // always will return an array with 2 integer items;
        //    exceptional invalid data conditions are not implemented
        let returnValue = [];
        let numParts = strValue.split('-');
        if (numParts.length === 0) {
            returnValue.push(0);
            returnValue.push(0);
        } else if (numParts.length === 1) {
            let number = parseInt(numParts[0]);
            returnValue.push(number);
            returnValue.push(number);
        } else if (numParts.length >= 2) {
            let number1 = parseInt(numParts[0]);
            let number2 = parseInt(numParts[1]);
            returnValue.push(number1);
            returnValue.push(number2);
        }
        return returnValue;
    }

    getChapterDMByPageNumber(number) {
        if (!this.isLoaded || this.chapters.length === 0) {
            return null;
        }

        let chapterDM = null;
        this.chapters.map((tmpChapterDM, index) => {
            if (chapterDM !== null) {
                // if already found, just exit.
                return null;
            } 

            let pageRangeArr = BookDM.parsePageRangeIntoArray(tmpChapterDM.pageNumberRange);
            if (number >= pageRangeArr[0] && number <= pageRangeArr[1]) {
                chapterDM = tmpChapterDM;
            }

            if (chapterDM === null && index === this.chapters.length -1 && number > pageRangeArr[1]) {
                // if number is greater than the last page number of this book return the last chapter
                chapterDM = tmpChapterDM;
            }

            return null;
        });

        return chapterDM;
    }
}

class ChapterDM {
    constructor() {
        this.basePath = '';
        this.title = '';
        this.pageNumberRange = '';
        this.configxml = '';
        this.isLoaded = false;
        this.pages = [];
    }

    getPageDMByPageNumber(number) {
        if (!this.isLoaded || this.pages.length === 0) {
            return null;
        }

        let pageDM = null;
        this.pages.map((tmpPageDM, index) => {
            if (pageDM !== null) {
                // if already found, just exit.
                return null;
            } 

            let pageRangeArr = BookDM.parsePageRangeIntoArray(tmpPageDM.pageNumberRange);
            if (number >= pageRangeArr[0] && number <= pageRangeArr[1]) {
                pageDM = tmpPageDM;
            }

            if (pageDM === null && index === this.pages.length -1 && number > pageRangeArr[1]) {
                // if number is greater than the last page number of this chapter return the last page
                pageDM = tmpPageDM;
            }

            return null;
        });

        return pageDM;        
    }

}



class PageDM {
    constructor() {
        this.basePath = '';
        this.pageUrl = '';
        this.pageNumberRange = '';
        this.text = ''; // flashcard text
        this.sentence = ''; // flashcard sentence
        this.words = [];
        this.videos = [];
        this.audios = [];
        this.exercises = [];
        this.links = [];
        this.config = {
            answerResultIndicatorSize: 18,
            drawingLineThickness: 2,
            fontSize: 19
        };
    }

}

class ExerciseDM {
    constructor() {
        this.handle = null;
        this.zoomInits = [];
        this.preloadedLabels = [];
        this.audios = [];
        this.videos = [];
        this.destinationButtons = [];
        this.questions = [];
        this.puzzleFindWordsDM = null;
        this.config = {
            answerResultIndicatorSize: 18,
            drawingLineThickness: 2,
            fontSize: 19
        };
    }
}

class LinkDM {
    constructor() {
        this.handle = null;
        this.url = '';
    }
}

class AudioVideoDM {
    constructor() {
        this.title = '';
        this.src = '';
        this.autoplay = false;
    }
}

class RectangleDM {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.w = 100;
        this.h = 100;
    }

    setX1Y1X2Y2(x1, y1, x2, y2) {
        if (x1 === undefined || x1 === null) {
            x1 = 0;
        }

        if (y1 === undefined || y1 === null) {
            y1 = 0;
        }

        if (x2 === undefined || x2 === null) {
            x2 = 0;
        }

        if (y2 === undefined || y2 === null) {
            y2 = 0;
        }

        if (x1 < x2) {
            this.x = +x1;
        } else {
            this.x = +x2;
        }
        this.w = Math.abs(x1 - x2);

        if (y1 < y2) {
            this.y = +y1;
        } else {
            this.y = +y2;
        }
        this.h = Math.abs(y1 - y2);
    } 
}

class ButtonDM extends RectangleDM {
    constructor() {
        super();

        // match_and_write_to_a_box specific options
		this.TYPE_SOURCE = 'source';
		this.TYPE_DESTINATION = 'destination';
		
		this.skipMatchedMark = false;
        this.type = this.TYPE_SOURCE;
		this.value = '';
        this.targetx = 0;
        this.targety = 0;
        this.targetw = 100;
        this.targeth = 100;

        this.rotation = 0;
        this.targetRotation = 0;

        this.visualButton = null;
    
        this.ignoreCase = false;


        // fill_in_the_blanks and match_and_write_to_a_box specific options
        this.correctAnswers = [];
        this.currentAnswers = [];

        this.align = 'center';

        this.visualResultIndicator = null;

        // crossword puzzle label models
		this.labelModels = [];
		this.displayCase = 'upper';

        // coloring models
        this.pathModels = [];

        // match words to make sentece specific options
        this.id = ''; // string unique id
        this.nextbtns = ''; // comma seperated string of ids
        this.nextbtnsarray = []; // parsed version of nextbtns string value

    }

    setTargetX1Y1X2Y2(x1, y1, x2, y2) {
        if (x1 < x2) {
            this.targetx = +x1;
        } else {
            this.targetx = +x2;
        }
        this.targetw = Math.abs(x1 - x2);

        if (y1 < y2) {
            this.targety = +y1;
        } else {
            this.targety = +y2;
        }
        this.targeth = Math.abs(y1 - y2);
    } 
}

class LabelDM extends RectangleDM {
    constructor() {
        super();
        this.value = '';
        this.skip = false;
        this.align = 'center';
        this.displayCase = 'upper';
        this.rotation = 0;
        this.textObject = null;
    }
}

class HandleDM extends RectangleDM {
    constructor() {
        super();
        this.visualButton = null;
    }
}

class ZoomInitDM extends RectangleDM {
    constructor() {
        super();
        this.blurifies = [];
    }
}

class BlurifyDM extends RectangleDM {
    constructor() {
        super();
        this.visualSprite = null;
    }
}

class QuestionDM {
    constructor() {
        this.sequence = '1';
        this.type = 'circle_the_correct_one';
        this.selectionBoxFontSize = 32;
        this.buttons = [];
        this.words = [];
        this.groupingAnswers = [];
        this.isAnswerShown = false;
        this.isChecked = false;
        this.alternateValues = [];
        this.alternateLabels = [];
    }
}

class WordDM {
    constructor() {
        this.srcRow = 0;
        this.srcCol = 0;
        this.dstRow = 0;
        this.dstCol = 0;
        this.value = 'E';
    }

    setStartButton(csv) {
        let valueArr = csv.split(',');
        if (valueArr.length !== 2) {
            this.srcRow = 0;
            this.srcCol = 0;
            return;
        }

        this.srcRow = parseInt(valueArr[0]);
        this.srcCol = parseInt(valueArr[1]);
    }

    setEndButton(csv) {
        let valueArr = csv.split(',');
        if (valueArr.length !== 2) {
            this.dstRow = 0;
            this.dstCol = 0;
            return;
        }

        this.dstRow = parseInt(valueArr[0]);
        this.dstCol = parseInt(valueArr[1]);
    }

}

class PuzzleFindWordsDM extends RectangleDM {
    constructor() {
        super();
        this.rows = 0;
        this.columns = 0;
        this.margin = 2;
        this.rotation = 0;
        this.buttons = null;
        this.visualContainer = null;
    }
}

class MainMenuDM {
    constructor() {
        this.appInfo = { name: 'i-TEAM', version: 'v3.1' };
        this.basePath = 'data';
        this.mainMenuDecoration = { backgroundImage: 'mainmenu/background.png',
                                    backgroundMasterLogo: 'mainmenu/background_logo.png',
                                    titlebarBgColor: '#006738',
                                    titlebarContentColor: '#FFFFFF'};
        this.items = [];
        this.isLoaded = false;
    }

    getSectionItems() {
        let sectionItems = [];
        this.items.map(tmpSectionItem => {
            sectionItems.push({sectiontitle: tmpSectionItem.title, sectionitem: tmpSectionItem});
            return null;
        });

        return sectionItems;
    }

}

class MainMenuItemDM {
    constructor() {
        this.basePath = 'data';
        this.title = 'NO TITLE';
        this.id = 'NO ID';
        this.type = 'book';
        this.configxml = 'no xml';
        this.bookDM = null;
        this.gameMenuDM = null;
        this.isLoaded = false;
    }

    getUnitItems() {
        if (this.bookDM === null) {
            return [{unitname: 'NOT LOADED', description: 'Not Loaded', chapterdm: null}];
        }
        let unitItems = []
        this.bookDM.chapters.map((tmpChapterDM, index) => {
            let tmpArr = tmpChapterDM.title.split(':');
            if (tmpArr.length >= 2) {
                unitItems.push({unitname: tmpArr[0].trim(), description: tmpArr[1].trim(), chapterindex: index});
            } else if (tmpArr.length === 1) {
                unitItems.push({unitname: tmpArr[0].trim(), description: '', chapterindex: index});
            }
            return null;
        });
        return unitItems;
    }
}


class DictionaryConfigDM {
    constructor() {
        this.basePath = '';
        this.showEnglishMeaning = true;
        this.showTurkishMeaning = true;
        this.showType = true;
        this.showSynonym = true;
        this.showAntonym = true;
        this.showExamples = true;
        this.classPrefix = 'C2';
        this.units = [
            {unit_value: 'U01', unit_name: 'UNIT 1'},
            {unit_value: 'U02', unit_name: 'UNIT 2'},
            {unit_value: 'U03', unit_name: 'UNIT 3'},
            {unit_value: 'U04', unit_name: 'UNIT 4'},
            {unit_value: 'U05', unit_name: 'UNIT 5'},
            {unit_value: 'U06', unit_name: 'UNIT 6'},
            {unit_value: 'U07', unit_name: 'UNIT 7'},
            {unit_value: 'U08', unit_name: 'UNIT 8'},
            {unit_value: 'U09', unit_name: 'UNIT 9'},
            {unit_value: 'U10', unit_name: 'UNIT 10'}
        ];
        this.words = [];
    }
}

class DictionaryWordDM {
    constructor() {
        this.text = null;
        this.synonym = null;
        this.antonym = null;
        this.type = null;
        this.meaningTR = null;
        this.meaningEN = null;
        this.labels = null;
        this.sentences = [];
        this.imageUrl = null;
        this.audioUrl = null;
    }

}



class ColorsDM {
    static black = {colorname: 'black', colorcodehtml: '#000000', colorcode: 0x000000};
    static white = {colorname: 'white', colorcodehtml: '#FFFFFF', colorcode: 0xFFFFFF};
    static grey = {colorname: 'grey', colorcodehtml: '#828282', colorcode: 0x828282};
    static gray = {colorname: 'gray', colorcodehtml: '#828282', colorcode: 0x828282};
    static navy = {colorname: 'navy', colorcodehtml: '#2E3191', colorcode: 0x2E3191};
    static brown = {colorname: 'brown', colorcodehtml: '#A54A00', colorcode: 0xA54A00};
    static green = {colorname: 'green', colorcodehtml: '#0DB500', colorcode: 0x0DB500};
    static blue = {colorname: 'blue', colorcodehtml: '#00A4FF', colorcode: 0x00A4FF};
    static purple = {colorname: 'purple', colorcodehtml: '#C000FF', colorcode: 0xC000FF};
    static pink = {colorname: 'pink', colorcodehtml: '#FF69B4', colorcode: 0xFF69B4};
    static yellow = {colorname: 'yellow', colorcodehtml: '#FFF800', colorcode: 0xFFF800};
    static orange = {colorname: 'orange', colorcodehtml: '#FF8500', colorcode: 0xFF8500};
    static red = {colorname: 'red', colorcodehtml: '#FF0000', colorcode: 0xFF0000};

    static findColorModelByName(value) {
        if (value === 'black') {
            return ColorsDM.black;
        } else if (value === 'white') {
            return ColorsDM.white;
        } else if (value === 'grey') {
            return ColorsDM.grey;
        } else if (value === 'gray') {
            return ColorsDM.gray;
        } else if (value === 'brown') {
            return ColorsDM.brown;
        } else if (value === 'green') {
            return ColorsDM.green;
        } else if (value === 'blue') {
            return ColorsDM.blue;
        } else if (value === 'purple') {
            return ColorsDM.purple;
        } else if (value === 'pink') {
            return ColorsDM.pink;
        } else if (value === 'yellow') {
            return ColorsDM.yellow;
        } else if (value === 'orange') {
            return ColorsDM.orange;
        } else if (value === 'red') {
            return ColorsDM.red;
        } else {
            return ColorsDM.navy;
        }
    }
}

var iteamColorModelInstance = (function () {
    var color = ColorsDM.navy;

    var changeColorCallBack = null;


    return {
        setColor: function (newColor) {
            color = {...newColor};
            if (changeColorCallBack !== null) {
                changeColorCallBack();
            }
        },
        getColor: function () {
            return color;
        },
        setChangeColorCallBack: function (callback) {
            changeColorCallBack = callback;
        }
    };
})();


class ITeamModes {
    static interaction = 'INTERACTION';
    static pen = 'PEN';
    static marker = 'MARKER';
    static eraser = 'ERASER';
}

class ITeamDrawingSizes {
    static small = 'SMALL';
    static medium = 'MEDIUM';
    static large = 'LARGE';
}

var iteamWorkingModeInstance = (function () {
    var mode = ITeamModes.interaction;
    var penSize = ITeamDrawingSizes.small;
    var markerSize = ITeamDrawingSizes.small;
    var eraserSize = ITeamDrawingSizes.medium;

    var changeModeOrSizeCallBack = null;

    return {
        setMode: function (newMode) {
            switch (newMode) {
                case ITeamModes.interaction:
                case ITeamModes.pen:
                case ITeamModes.marker:
                case ITeamModes.eraser:
                    mode = newMode;
                    if (changeModeOrSizeCallBack !== null) {
                        changeModeOrSizeCallBack();
                    }
                    break;
                default: mode = ITeamModes.interaction;
                    break;
            }
            mode = newMode;
        },
        setDrawingSize: function (newSize) {
            switch (newSize) {
                case ITeamDrawingSizes.small:
                case ITeamDrawingSizes.medium:
                case ITeamDrawingSizes.large:
                    break;
                default:
                    newSize = ITeamDrawingSizes.small;
                    break;
            }

            switch (mode) {
                case ITeamModes.pen:
                    penSize = newSize;
                    break;
                case ITeamModes.marker:
                    markerSize = newSize;
                    break;
                case ITeamModes.eraser:
                    eraserSize = newSize;
                    break;
                default:
                    break;
            }

            if (changeModeOrSizeCallBack !== null) {
                changeModeOrSizeCallBack();
            }
        },
        getDrawingSizeOfMode: function (mode) {
            switch (mode) {
                case ITeamModes.pen:
                    return penSize;
                case ITeamModes.marker:
                    return markerSize;
                case ITeamModes.eraser:
                    return eraserSize;
                default:
                    return penSize;
            }
        },
        getMode: function() {
            return mode;
        },
        setChangeModeOrSizeCallBack: function (callback) {
            changeModeOrSizeCallBack = callback;
        },
        eraseAllDrawings: function() {
            if (changeModeOrSizeCallBack !== null) {
                changeModeOrSizeCallBack('eraseall');
            }
        }
    };
})();



var iteamMenuModelInstance = (function () {
    var mainMenuDM = null;
    var successPageModelCallBack = null;
    var failurePageModelCallBack = null;

    function _findFirstPageModelByChapterIndex(sectionItem, chapterIndex) {
        if (sectionItem.type !== 'book') {
            return null;
        }

        if (sectionItem.bookDM === null) {
            return null;
        }

        if (!sectionItem.bookDM.isLoaded) {
            return null;
        }


        let bookDM = sectionItem.bookDM;
        let chapterDM = bookDM.chapters[chapterIndex];

        if (!chapterDM.isLoaded) {
            let pageRangeArr = BookDM.parsePageRangeIntoArray(chapterDM.pageNumberRange);
            bookDM.runtime.currentPageNumber = pageRangeArr[0];
            loadChapterContent(bookDM, chapterIndex); // chapter index
        } else {
            let pageDM = chapterDM.pages[0];
            let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
            bookDM.runtime.currentPageNumber = pageRangeArr[0];
            bookDM.runtime.currentPageModel = pageDM;
            bookDM.runtime.currentChapterModel = chapterDM;
            
            if (successPageModelCallBack !== null) {
                successPageModelCallBack(bookDM, chapterDM, pageDM);
                successPageModelCallBack = null;
                failurePageModelCallBack = null;
            }
        }
    }

    function _findSublingPageModelByCurrentPageModel(sectionItem, findNext = true) {
        if (sectionItem.type !== 'book') {
            return null;
        }

        if (sectionItem.bookDM === null) {
            return null;
        }

        if (sectionItem.bookDM.runtime.currentPageModel === null) {
            return null;
        }

        let bookDM = sectionItem.bookDM;
        let currentPageModel = bookDM.runtime.currentPageModel;
        let chapterDM = null;
        let chapterDMIndex = -1;
        let pageDM = null;
        let pageDMIndex = -1;
        
        bookDM.chapters.map((tmpChapterDM, indexChapter) => {
            if (chapterDM !== null || chapterDMIndex !== -1 || pageDMIndex !== -1) {
                return null;
            }

            if (!tmpChapterDM.isLoaded) {
                return null;
            }

            tmpChapterDM.pages.map((tmpPageDM, indexPage) => {
                if (tmpPageDM === currentPageModel) {
                    chapterDM = tmpChapterDM;
                    chapterDMIndex = indexChapter;
                    pageDMIndex = indexPage;
                }
                return null;
            });

            return null;
        });

        if (chapterDM === null && chapterDMIndex === -1 && pageDMIndex === -1) {
            // not found, impossible but return immediately
            return;
        }

        if (findNext) {
            // find Next
            if (pageDMIndex < chapterDM.pages.length - 1) {
                pageDMIndex++;
                pageDM = chapterDM.pages[pageDMIndex];
                let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
                bookDM.runtime.currentPageModel = pageDM;
                bookDM.runtime.currentPageNumber = pageRangeArr[0];
                bookDM.runtime.currentChapterModel = chapterDM;
                if (successPageModelCallBack !== null) {
                    successPageModelCallBack(bookDM, chapterDM, pageDM);
                    successPageModelCallBack = null;
                    failurePageModelCallBack = null;
                }
                return;
            } else {
                // we must switch to next chapter if available
                if (chapterDMIndex >= bookDM.chapters.length - 1) {
                    // the chapter is last one, there is no more chapters and no more next subling pages, do nothing.
                    return;
                }

                chapterDMIndex++;
                chapterDM = bookDM.chapters[chapterDMIndex];

                if (chapterDM.isLoaded) {

                    pageDM = chapterDM.pages[0];
                    let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
                    bookDM.runtime.currentPageModel = pageDM;
                    bookDM.runtime.currentPageNumber = pageRangeArr[0];
                    bookDM.runtime.currentChapterModel = chapterDM;
                    if (successPageModelCallBack !== null) {
                        successPageModelCallBack(bookDM, chapterDM, pageDM);
                        successPageModelCallBack = null;
                        failurePageModelCallBack = null;
                    }
                    return;
                } else {

                    // chapter is not loaded, request to load it
                    let pageRangeArr = BookDM.parsePageRangeIntoArray(chapterDM.pageNumberRange);
                    bookDM.runtime.currentPageNumber = pageRangeArr[0];
                    loadChapterContent(bookDM, chapterDMIndex); // chapter index
                }
            }
        } else {
            //find Previous
            if (pageDMIndex > 0) {
                pageDMIndex--;
                pageDM = chapterDM.pages[pageDMIndex];
                let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
                bookDM.runtime.currentPageModel = pageDM;
                bookDM.runtime.currentPageNumber = pageRangeArr[0];
                bookDM.runtime.currentChapterModel = chapterDM;
                if (successPageModelCallBack !== null) {
                    successPageModelCallBack(bookDM, chapterDM, pageDM);
                    successPageModelCallBack = null;
                    failurePageModelCallBack = null;
                }
                return;
            } else {
                // we must switch to prev chapter if available
                if (chapterDMIndex === 0) {
                    // the chapter is first one, there is no previous chapters and no more prev subling pages, do nothing.
                    return;
                }

                chapterDMIndex--;
                chapterDM = bookDM.chapters[chapterDMIndex];

                if (chapterDM.isLoaded) {
                    pageDM = chapterDM.pages[chapterDM.pages.length - 1];
                    let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
                    bookDM.runtime.currentPageModel = pageDM;
                    bookDM.runtime.currentPageNumber = pageRangeArr[0];
                    bookDM.runtime.currentChapterModel = chapterDM;
                    if (successPageModelCallBack !== null) {
                        successPageModelCallBack(bookDM, chapterDM, pageDM);
                        successPageModelCallBack = null;
                        failurePageModelCallBack = null;
                    }
                    return;
                } else {
                    // chapter is not loaded, request to load it
                    let pageRangeArr = BookDM.parsePageRangeIntoArray(chapterDM.pageNumberRange);
                    bookDM.runtime.currentPageNumber = pageRangeArr[1];
                    loadChapterContent(bookDM, chapterDMIndex); // chapter index
                }
            }
        }
    }


    function _findCurrentPageModelByPageNumber(sectionItem) {
        // this funtion loads the corresponding data if needed, then returns back PageDM
    
        if (sectionItem.type !== 'book') {
            return null;
        }
        
        if (sectionItem.bookDM === null) {
            // bookDM is NOT loaded, lets load it.
            getXmlFile(`${sectionItem.basePath}/${sectionItem.configxml}`, 
                            (response) => httpXmlTypeBookResponseSuccess(response, sectionItem), 
                            httpXmlTypeBookResponseFailure);
        } else {
            // bookDM is loaded
            let bookDM = sectionItem.bookDM;
            let currentPageNumber = bookDM.runtime.currentPageNumber;
            let chapterDM = null;
            let chapterIndex = 0;
            bookDM.chapters.map((tmpChapterDM, index) => {
                let pageRangeArr = BookDM.parsePageRangeIntoArray(tmpChapterDM.pageNumberRange);
                if (currentPageNumber >= pageRangeArr[0] && currentPageNumber <= pageRangeArr[1]) {
                    // we found the chapter that contains the currentPageNumber
                    chapterDM = tmpChapterDM;
                    chapterIndex = index;
                }
                return null;
            });
            
            if (chapterDM === null) {
                return null;
            }

            if (!chapterDM.isLoaded) {
                // chapterDM is not loaded, load it first
                loadChapterContent(bookDM, chapterIndex); // chapter index
            } else {
                // chapterDM is loaded, continue with hierarchy to search for page
                let pageDM = null;
                chapterDM.pages.map((tmpPageDM, index) => {
                    let pageRangeArr = BookDM.parsePageRangeIntoArray(tmpPageDM.pageNumberRange);
                    if (currentPageNumber >= pageRangeArr[0] && currentPageNumber <= pageRangeArr[1]) {
                        // we found the page that contains the currentPageNumber
                        pageDM = tmpPageDM;
                    }

                    return null;
                });

                if (pageDM === null) {
                    return null;
                }

                bookDM.runtime.currentPageModel = pageDM;
                let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
                bookDM.runtime.currentPageNumber = pageRangeArr[0];
                bookDM.runtime.currentChapterModel = chapterDM;

                if (successPageModelCallBack !== null) {
                    successPageModelCallBack(bookDM, chapterDM, pageDM);
                    successPageModelCallBack = null;
                    failurePageModelCallBack = null;
                }
            }
        }
    }

    
    function httpXmlTypeBookResponseSuccess(response, sectionItem) {
        
        // loads book.xml
        let bookXmlFullPath = `${sectionItem.basePath}/${sectionItem.configxml}`;
        let pathParts = bookXmlFullPath.split('/');
        pathParts.splice(pathParts.length - 1, 1);
        let basePath = pathParts.join('/');
    
        let bookJS = parseXMLtoJS(response.data);
        let bookDM = prepareBookDataModel(bookJS);
        sectionItem.bookDM = bookDM;
        sectionItem.isLoaded = true;
        bookDM.basePath = basePath;
        bookDM.runtime.currentPageNumber = 0; // initialize it to 0. newly loaded.
    
        if (bookDM.chapters.length <= 0) { // exceptional situation, don't know what to do.
            return;
        }
    
        let chapterDM = bookDM.chapters[0]; // get the first chapter
    
        let pageNumArr = BookDM.parsePageRangeIntoArray(chapterDM.pageNumberRange);
        bookDM.runtime.currentPageNumber = pageNumArr[0]; // first page number of the book
    
        loadChapterContent(bookDM, 0); // chapter index
        
    }
    
    function httpXmlTypeBookResponseFailure(error) {
        console.log(error);
        if (failurePageModelCallBack !== null) {
            failurePageModelCallBack(error);
            failurePageModelCallBack = null;
            successPageModelCallBack = null;
        }
    }
    
    
    function loadChapterContent(bookDM, index) {
        let chapterDM = bookDM.chapters[index];
        if (chapterDM.isLoaded) {
            return;
        }
    
        let chapterXmlFullPath = `${bookDM.basePath}/${chapterDM.configxml}`;
        let pathParts = chapterXmlFullPath.split('/');
        pathParts.splice(pathParts.length - 1, 1);
        let basePath = pathParts.join('/');
        chapterDM.basePath = basePath;
    
        getXmlFile(`${chapterXmlFullPath}`, 
                        (response) => httpXmlTypeChapterResponseSuccess(response, bookDM, index), 
                        httpXmlTypeChapterResponseFailure);
    
    }
    
    function httpXmlTypeChapterResponseSuccess(response, bookDM, index) {
        let chapterDMNotLoaded = bookDM.chapters[index];
        let chapterJS = parseXMLtoJS(response.data);
        let chapterDM = prepareChapterDataModel(bookDM, chapterJS, chapterDMNotLoaded.basePath);
        chapterDM.isLoaded = true;
        chapterDM.title = chapterDMNotLoaded.title;
        chapterDM.pageNumberRange = chapterDMNotLoaded.pageNumberRange;
        chapterDM.configxml = chapterDMNotLoaded.configxml;
        chapterDM.basePath = chapterDMNotLoaded.basePath;
        bookDM.chapters[index] = chapterDM; // replace not loaded chapterDM with loaded one
    
        let currentPageNumber = bookDM.runtime.currentPageNumber;
    
        // chapterDM is loaded, continue with hierarchy to search for page
        let pageDM = null;
        chapterDM.pages.map(tmpPageDM => {
            let pageRangeArr = BookDM.parsePageRangeIntoArray(tmpPageDM.pageNumberRange);
            if (currentPageNumber >= pageRangeArr[0] && currentPageNumber <= pageRangeArr[1]) {
                // we found the page that contains the currentPageNumber
                pageDM = tmpPageDM;
            }

            return null;
        });
        
        if (pageDM === null) {
            return null;
        }

        bookDM.runtime.currentPageModel = pageDM;
        let pageRangeArr = BookDM.parsePageRangeIntoArray(pageDM.pageNumberRange);
        bookDM.runtime.currentPageNumber = pageRangeArr[0];
        bookDM.runtime.currentChapterModel = chapterDM;
        if (successPageModelCallBack !== null) {
            successPageModelCallBack(bookDM, chapterDM, pageDM);
            successPageModelCallBack = null;
            failurePageModelCallBack = null;
        }
    
    }
    
    function httpXmlTypeChapterResponseFailure(error) {
        if (failurePageModelCallBack !== null) {
            failurePageModelCallBack(error);
            failurePageModelCallBack = null;
            successPageModelCallBack = null;
        }
    }


    return { // public interface
        setIteamMenuModelInstance: function (model) {
            mainMenuDM = model;
        },
        getIteamMenuModelInstance: function () {
            return mainMenuDM;
        },
        findCurrentPageModelByPageNumber: function (sectionItem, successCallBack, errorCallBack) {
            successPageModelCallBack = successCallBack;
            failurePageModelCallBack = errorCallBack;
            _findCurrentPageModelByPageNumber(sectionItem);
        },
        navigateToNextPageModel: function (sectionItem, successCallBack, errorCallBack) {
            successPageModelCallBack = successCallBack;
            failurePageModelCallBack = errorCallBack;
            _findSublingPageModelByCurrentPageModel(sectionItem, true);
        },
        navigateToPrevPageModel: function (sectionItem, successCallBack, errorCallBack) {
            successPageModelCallBack = successCallBack;
            failurePageModelCallBack = errorCallBack;
            _findSublingPageModelByCurrentPageModel(sectionItem, false);
        },
        navigateToChapterIndex: function (sectionItem, chapterIndex, successCallBack, errorCallBack) {
            successPageModelCallBack = successCallBack;
            failurePageModelCallBack = errorCallBack;
            _findFirstPageModelByChapterIndex(sectionItem, chapterIndex);
        },
    };
})();


var normalizeUserInput = function (value) {
    let normalizedValue = value;
    
    let re;
    re = /’/g;
    normalizedValue = normalizedValue.replaceAll(re, '\'');
    re = /‘/g;
    normalizedValue = normalizedValue.replaceAll(re, '\'');
    re = /”/g;
    normalizedValue = normalizedValue.replaceAll(re, '"');
    re = /“/g;
    normalizedValue = normalizedValue.replaceAll(re, '"');
    re = / *$/g; // remove trailing spaces...
    normalizedValue = normalizedValue.replaceAll(re, '');
    re = /^ */g; // remove heading spaces...
    normalizedValue = normalizedValue.replaceAll(re, '');
    re = / +/g; // change multiple spaces with a single one...
    normalizedValue = normalizedValue.replaceAll(re, ' ');
    re = / ([.,!?;])/g; // eat space before punctuation char...
    normalizedValue = normalizedValue.replaceAll(re, '$1');
    re = /([.,!?;])([^ 0-9])/g; // add space after punctuation char...
    normalizedValue = normalizedValue.replaceAll(re, '$1 $2');
    
    return normalizedValue;
}


export {
    BookDM,
    ChapterDM,
    PageDM,
    RectangleDM,
    ExerciseDM,
    LinkDM,
    AudioVideoDM,
    QuestionDM,
    ButtonDM,
    WordDM,
    LabelDM,
    PuzzleFindWordsDM,
    HandleDM,
    ZoomInitDM,
    BlurifyDM,
    MainMenuDM,
    MainMenuItemDM,
    DictionaryConfigDM,
    DictionaryWordDM,
    ColorsDM,
    ITeamModes,
    ITeamDrawingSizes,
    iteamMenuModelInstance,
    iteamColorModelInstance,
    iteamWorkingModeInstance,
    normalizeUserInput
};

